'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

const WeatherContingency = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const contingencyPlans = [
    {
      condition: 'Rain',
      plan: 'Ceremony will move to the indoor chapel with full climate control. Reception remains in the main ballroom as planned.',
      icon: 'CloudIcon',
    },
    {
      condition: 'Extreme Heat',
      plan: 'Additional cooling stations and refreshments will be provided. Ceremony time may be adjusted to early evening.',
      icon: 'SunIcon',
    },
  ];

  if (!isHydrated) {
    return (
      <div className="bg-card rounded-lg shadow-sacred-md p-8">
        <div className="h-8 bg-surface rounded w-1/3 mb-6 animate-pulse" />
        <div className="space-y-4">
          <div className="h-24 bg-surface rounded animate-pulse" />
          <div className="h-24 bg-surface rounded animate-pulse" />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-sacred-md p-8">
      <div className="flex items-center space-x-3 mb-6">
        <Icon name="CloudIcon" size={28} className="text-primary" />
        <h3 className="font-playfair text-2xl font-semibold text-foreground">Weather Contingency Plans</h3>
      </div>

      <p className="font-inter text-sm text-muted-foreground mb-6">
        We have prepared for all weather conditions to ensure your comfort and the success of our celebration.
      </p>

      <div className="space-y-4">
        {contingencyPlans.map((item, index) => (
          <div key={index} className="p-6 bg-surface rounded-lg border border-border">
            <div className="flex items-start space-x-3 mb-3">
              <Icon name={item.icon as any} size={24} className="text-secondary" />
              <h4 className="font-inter text-base font-semibold text-foreground">{item.condition}</h4>
            </div>
            <p className="font-inter text-sm text-muted-foreground">{item.plan}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-primary/10 rounded-md">
        <p className="font-inter text-sm text-foreground">
          <strong>Updates:</strong> Any weather-related changes will be communicated via email and text message 24 hours before the event.
        </p>
      </div>
    </div>
  );
};

export default WeatherContingency;